import { ProgressBar, Typography } from '@packages/ui/shared';
import { createUseStyles } from 'react-jss';

import { ssm5ControlStyles, ssm5TextStyles } from '../ssm5.styles';

/** Props for {@link Ssm5LoaderBar}. */
export type Ssm5LoaderBarProps = {
    /** The message under the bar. */
    message: string;
    /** How far the bar is, from 0 to 100. */
    percent: number;
};

const useStyles = createUseStyles({
    loader: {
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        gap: 33,
        justifyContent: 'center',
    },
});

/**
 * The SSM5 loading state: a loader bar centered over its message, filling the space it is given.
 *
 * @param props - {@link Ssm5LoaderBarProps}
 * @returns the loader
 */
export function Ssm5LoaderBar({ message, percent }: Ssm5LoaderBarProps) {
    const classes = useStyles();

    return (
        <div className={classes.loader}>
            <ProgressBar percent={percent} style={ssm5ControlStyles.loaderBar} />
            <Typography color="textDarkSecondary" style={ssm5TextStyles.sectionTitle} variant="h3">
                {message}
            </Typography>
        </div>
    );
}
